import React, {useRef, useContext, useEffect} from "react";
import BasicView from "../../components/BasicView";
import HeadsVies from "../../styles/HeadsVies";
import DownArrow from "../../components/DownArrow";
import scrollToRef from "../../constants/DownAction";
import {SecondView} from "../../styles/HeadView";
import {Content} from "../../styles/GlobalStyles";
import ContactActionForm from "../../components/contact/ContactActionForm";
import ExperienceContainer from "./components/ExperienceContainer";
import {isMobile} from "../../constants/Helpers";
import {HeadersContext} from "../../context/HeadersContext";
import {LoadComponet} from "../../components/loaders/Loader";
import parse from "html-react-parser";
import {CoursesContext} from "../../context/CoursesContext";
import useSetTitle from "../../hooks/useSetTitle";

//const scrollToRef = ref => window.scrollTo({top: ref.current.offsetTop, behavior: "smooth"});

export default function DomecqExperiences() {
   useSetTitle("Programa Emblem");
   const {getHeader, emblemHeader} = useContext(HeadersContext);
   const {getEmblem, emblem} = useContext(CoursesContext);
   const ContactRef = useRef(null);
   const fatherRef = useRef(null);
   const goToContact = () => {
      // console.log();
      window.scrollTo({top: ContactRef.current.offsetTop + ContactRef.current.offsetHeight, behavior: "smooth"});
   };
   const DExperiences = useRef(null);
   const goTo = () => scrollToRef(DExperiences);

   useEffect(() => {
      getHeader("Emblem");
   }, []);

   useEffect(() => {
      if (!emblemHeader.loading) {
         getEmblem();
      }
   }, [emblemHeader]);

   if (emblemHeader.loading) return <LoadComponet isVisible={true} />;

   return (
      <BasicView
         imageBack={`http://domecqapi.trebolbit.com/${isMobile ? emblemHeader.pathImageWebMobile : emblemHeader.pathImageWebDesktop}`}
      >
         <HeadsVies
            type={3}
            description="Este programa está diseñado para aquellos lideres consolidados de la industria que se interesan en temas de vanguardia y noveades. Una experiencia donde se conectan con otros lideres para intercambiar puntos de vista en cualquier ambiente selecto y enriquecedor."
            title={
               isMobile ? (
                  "Programa Emblem domecq"
               ) : (
                  <span>
                     Programa <br /> Emblem domecq
                  </span>
               )
            }
            icon={require("../../assets/icons/diamon_circle.png")}
         />

         <SecondView ref={fatherRef}>
            <DownArrow goTo={goTo} />
            <Content ref={DExperiences}>
               {emblem.isLoading ? <LoadComponet isVisible={true} /> : <ExperienceContainer contact={goToContact} data={emblem.offer} />}
               <ContactActionForm
                  icon={require("../../assets/icons/contact_icon.png")}
                  centerBtn={true}
                  title="Ponte en contacto"
                  width="100%"
                  ref={ContactRef}
                  showDesc={true}
                  type="emblem"
               />
            </Content>
         </SecondView>
      </BasicView>
   );
}
